import { useState } from 'react'

const usePageController = () => {
  const pageUrl = window.location.pathname.split('/')[1]
  const [pageController, setPageController] = useState({
    mainPage: pageUrl === '',
    collections:
      pageUrl.includes('collections') || pageUrl.includes('collection'),
    courses: pageUrl.includes('courses'),
  })

  const updatePageController = () => {
    const currentPageUrl = window.location.pathname.split('/')[1]
    setPageController({
      mainPage: currentPageUrl === '',
      collections:
        currentPageUrl.includes('collections') || currentPageUrl.includes('collection'),
      courses: currentPageUrl.includes('courses'),
    })
  }

  const showUpgrade = pageUrl !== 'mini-course'

  return { pageController, updatePageController, showUpgrade }
}

export default usePageController
